export default "__VITE_ASSET__DdI5P0ZE__"